import React from 'react'
import CenteredModal from './modals/centered-modal'
import { Box, Typography } from '@mui/material'
import { SquareButton, VBox, HBox } from '../elements/basic-elements'
import CloseIcon from '../images/icons/close-icon'
import CardStandard from './card-standard'
import IconTag from './icon-tag'
import PrimaryButton from './buttons/primary-button'
import { navigate } from 'gatsby'
import WcidLogo from '../images/icons/wcid_logo'
import PremiumIcon from '../images/icons/premium-icon'

export interface GetMembershipModalContent {
  headline?: string
  description?: string
  features?: readonly string[]
  cta?: string
}

interface GetMembershipModalProps {
  content: GetMembershipModalContent
  open: boolean
  onClose: () => void
}

const GetMembershipModal = ({ content, open, onClose }: GetMembershipModalProps) => {
  return (
    // No coloured frame around the card at any size; the card is the modal.
    <CenteredModal open={open} onClose={onClose} disableContainer>
      <CardStandard
        sx={{
          position: 'relative',
          padding: { xs: '60px 20px 30px', sm: '70px 40px 30px' },
          width: { xs: '100%', sm: '527px' },
          alignSelf: 'center',
          // CenteredModal's disableContainer styles make inner papers scroll,
          // which suits the full-screen phone layout but leaves a scrollbar
          // around the card on larger screens.
          '&&.MuiPaper-root': { overflow: { xs: 'scroll', sm: 'visible' } }
        }}
      >
        <SquareButton
          variant="contained"
          color="infoSecondary"
          disableElevation
          sx={{ position: 'absolute', top: 20, right: 20 }}
          onClick={onClose}
        >
          <CloseIcon />
        </SquareButton>
        <Box display="flex" justifyContent="center" paddingBottom="25px">
          <WcidLogo />
        </Box>
        <VBox gap="30px" padding={{ xs: 0, md: '0px 40px' }}>
          <VBox
            gap="15px"
            sx={{ padding: { xs: 0, sm: '0px 21px' } }}
            justifyContent="center"
            textAlign="center"
          >
            <Typography variant="h4" color="textPrimary">
              {content?.headline}
            </Typography>
            <Typography variant="body2" color="textPrimary">
              {content?.description}
            </Typography>
          </VBox>
          <VBox padding={{ xs: '0px 25px', md: 0 }} gap="15px">
            {content?.features?.map(featureText => {
              return (
                <HBox gap={2.5} alignItems="center">
                  <Box>
                    <IconTag Icon={PremiumIcon} />
                  </Box>
                  <Typography variant="body2" color="textPrimary">
                    {featureText}
                  </Typography>
                </HBox>
              )
            })}
            <Box textAlign="center" paddingTop={{ xs: '5px', sm: '40px' }}>
              <PrimaryButton
                variant="contained"
                disableElevation
                fullWidth
                onClick={() => {
                  navigate('/register')
                }}
              >
                {content?.cta}
              </PrimaryButton>
            </Box>
          </VBox>
        </VBox>
      </CardStandard>
    </CenteredModal>
  )
}

export default GetMembershipModal
